module.exports = __webpack_public_path__ + "static/media/damlag2.75afd8f9.jpg";